import React from "react";
import { motion } from "framer-motion";
import ScrollToTop from "../../shared/utils/ScrollToTop";
import Layout from "../../shared/Layout";
import Heading from "../../shared/Heading";

import Cohort1Img from "../../assets/cohort2/1.png";
import Cohort2Img from "../../assets/cohort2/2.png";
import Cohort3Img from "../../assets/cohort2/3.png";
import Cohort4Img from "../../assets/cohort2/4.png";
import Cohort5Img from "../../assets/cohort2/5.png";
import Cohort6Img from "../../assets/cohort2/6.png";

export default function Cohort2() {
  const cohorts = [
    Cohort1Img,
    Cohort2Img,
    Cohort3Img,
    Cohort4Img,
    Cohort5Img,
    Cohort6Img,
  ];

  return (
    <>
      <ScrollToTop />
      <Layout>
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: "0%" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="pt-20"
        >
          <Heading firstHeading="Cohort 2" secondHeading="RMG StartUps" />

          <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 py-10">
            {cohorts.map((imgSrc, index) => (
              <div key={index} className="flex justify-center items-center">
                <img
                  src={imgSrc}
                  alt={`Cohort ${index + 1}`}
                  className="rounded-md shadow-md hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </motion.div>
      </Layout>
    </>
  );
}
